function cov_bxi1ftwjj() {
  var path = "/app/src/components/learn-more-how-it-works/learn-more-how-it-works.tsx";
  var hash = "558cde823ffd6a6b6749caa114f0446b0d64f915";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/learn-more-how-it-works/learn-more-how-it-works.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 35
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "1": {
        start: {
          line: 23,
          column: 12
        },
        end: {
          line: 23,
          column: 23
        }
      },
      "2": {
        start: {
          line: 25,
          column: 37
        },
        end: {
          line: 34,
          column: 3
        }
      },
      "3": {
        start: {
          line: 36,
          column: 21
        },
        end: {
          line: 36,
          column: 40
        }
      },
      "4": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 70,
          column: 4
        }
      },
      "5": {
        start: {
          line: 48,
          column: 10
        },
        end: {
          line: 61,
          column: 15
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 36
          }
        },
        loc: {
          start: {
            line: 22,
            column: 13
          },
          end: {
            line: 71,
            column: 1
          }
        },
        line: 22
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 47,
            column: 24
          },
          end: {
            line: 47,
            column: 25
          }
        },
        loc: {
          start: {
            line: 48,
            column: 10
          },
          end: {
            line: 61,
            column: 15
          }
        },
        line: 48
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 36,
            column: 21
          },
          end: {
            line: 36,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 21
          },
          end: {
            line: 36,
            column: 25
          }
        }, {
          start: {
            line: 36,
            column: 29
          },
          end: {
            line: 36,
            column: 40
          }
        }],
        line: 36
      },
      "1": {
        loc: {
          start: {
            line: 56,
            column: 15
          },
          end: {
            line: 56,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 15
          },
          end: {
            line: 56,
            column: 24
          }
        }, {
          start: {
            line: 56,
            column: 28
          },
          end: {
            line: 56,
            column: 33
          }
        }],
        line: 56
      },
      "2": {
        loc: {
          start: {
            line: 64,
            column: 7
          },
          end: {
            line: 68,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 7
          },
          end: {
            line: 64,
            column: 21
          }
        }, {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 67,
            column: 21
          }
        }],
        line: 64
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "558cde823ffd6a6b6749caa114f0446b0d64f915"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_bxi1ftwjj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_bxi1ftwjj();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import cn from 'classnames';
import React from 'react';
import { Typography } from 'src/components/v2/typography';
import { useLocale } from 'src/hooks/use-locale';
import styles from './styles.css';
cov_bxi1ftwjj().s[0]++;
export var LearnMoreHowItWorks = function LearnMoreHowItWorks(_ref) {
  var list = _ref.list,
    partnerCharges = _ref.partnerCharges,
    classNameRoot = _ref.classNameRoot,
    classNameTitle = _ref.classNameTitle,
    classNameList = _ref.classNameList;
  cov_bxi1ftwjj().f[0]++;
  var t = (cov_bxi1ftwjj().s[1]++, useLocale());
  var listDefault = (cov_bxi1ftwjj().s[2]++, [{
    text: t('choose_at_checkout_to_select_payment_plan')
  }, {
    text: t('tabbySimple.enter_your_information')
  }, {
    text: t('depending_on_your_plan')
  }, {
    text: t('we_will_send_you_a_reminder')
  }]);
  var listResult = (cov_bxi1ftwjj().s[3]++, (cov_bxi1ftwjj().b[0][0]++, list) || (cov_bxi1ftwjj().b[0][1]++, listDefault));
  cov_bxi1ftwjj().s[4]++;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(classNameRoot, styles.container)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "heading2",
    className: cn(styles.title, classNameTitle)
  }, t('tabbySimple.how_it_works')), /*#__PURE__*/React.createElement("ul", {
    className: cn(styles.list, classNameList)
  }, listResult.map(function (item, i) {
    var _ref2;
    cov_bxi1ftwjj().f[1]++;
    cov_bxi1ftwjj().s[5]++;
    return /*#__PURE__*/React.createElement("li", {
      key: item.text,
      className: styles.listItem
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      bold: true,
      className: cn(styles.howItWorksListItemCircle, _defineProperty({}, styles.howItWorksListItemCircleIcon, !!item.icon))
    }, (_ref2 = (cov_bxi1ftwjj().b[1][0]++, item.icon)) !== null && _ref2 !== void 0 ? _ref2 : (cov_bxi1ftwjj().b[1][1]++, i + 1)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: styles.text
    }, item.text));
  })), (cov_bxi1ftwjj().b[2][0]++, partnerCharges) && (cov_bxi1ftwjj().b[2][1]++, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1",
    className: styles.partnerCharges
  }, t('tabby_does_not_charge_any_additional_fees'))));
};